shadow$provide[443] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `vec2 screenPassUV(vec4 uvwo, vec4 stpq) {
  return uvwo.xy;
}
`;

};